export const prazenChecbox =
    [
        {
            id: "1", ime: " "
        }
    ]